import { render, staticRenderFns } from "./UploadHero.vue?vue&type=template&id=052d114a"
import script from "./UploadHero.vue?vue&type=script&lang=js"
export * from "./UploadHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports